import { render } from "./BackGeneralView.vue?vue&type=template&id=b55a39be"
import script from "./BackGeneralView.vue?vue&type=script&lang=js"
export * from "./BackGeneralView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__